angular.module('mychart').controller('ReferenceMaterialPrintDownloadModalCtrl',
    ['$scope', '$uibModalInstance', 'attachmentInfo',
        function ($scope, $modalInstance, attachmentInfo) {
            'use strict';

            $scope.attachmentInfo = attachmentInfo;
            $scope.loadingLabResult = false;

            function ok() {
                $modalInstance.close('ok');
            }

            function cancel() {
                $modalInstance.dismiss('cancel');
            }

            $scope.ok = ok;
            $scope.cancel = cancel;
        }]);